import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { range } from 'lodash';
import { ChevronLeftSmallIcon, ChevronRightSmallIcon } from '@hub/icon';
import { Box } from '@hub/box';
import { Link } from '@hub/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textDecoration: 'none',
  width: 'size-8',
  height: 'size-8'
};
export const generatePages = (currentPage, totalPages) => {
  const maxPageButtons = 5;
  // checks if current page is out of range
  let page = currentPage;
  if (currentPage < 0) {
    page = 0;
  } else if (currentPage > totalPages) {
    page = totalPages - 1;
  }
  let startPage = 0;
  let endPage = totalPages;
  if (totalPages >= maxPageButtons) {
    const medianPageDivisor = 2;
    const numberOfPagesBeforeCurrentPage = Math.floor(maxPageButtons / medianPageDivisor);
    const numberOfPagesAfterCurrentPage = Math.ceil(maxPageButtons / medianPageDivisor);
    if (page <= numberOfPagesBeforeCurrentPage) {
      startPage = 0;
      endPage = maxPageButtons;
    } else if (page + numberOfPagesAfterCurrentPage >= totalPages) {
      startPage = totalPages - maxPageButtons;
      endPage = totalPages;
    } else {
      startPage = page - numberOfPagesBeforeCurrentPage;
      endPage = page + numberOfPagesAfterCurrentPage;
    }
  }
  return range(startPage, endPage);
};
export const LinkPagination = _ref => {
  let {
    currentPage,
    totalPages,
    makePageLink,
    onLinkClick
  } = _ref;
  const onLinkClick_ = onLinkClick || (() => undefined);
  const pages = generatePages(currentPage, totalPages);
  const onFirstPage = currentPage === 0;
  const onLastPage = totalPages - 1 === currentPage;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'inline-flex'
    },
    "data-id": "pagination_index_LinkPagination_Box",
    children: [onFirstPage ? /*#__PURE__*/_jsx(Box, {
      sx: _objectSpread(_objectSpread({}, buttonStyles), {}, {
        pointerEvents: 'none'
      }),
      "data-id": "pagination_index_LinkPagination_Box_1",
      children: /*#__PURE__*/_jsx(ChevronLeftSmallIcon, {
        sx: {
          color: 'iconDisabled'
        },
        "data-id": "pagination_index_LinkPagination_Box_ChevronLeftSmallIcon"
      })
    }) : /*#__PURE__*/_jsx(Link, {
      href: makePageLink(currentPage - 1),
      prefetch: false,
      "aria-label": "Go to previous page",
      onClick: () => onLinkClick_(currentPage - 1),
      sx: _objectSpread({}, buttonStyles),
      "data-id": "pagination_index_LinkPagination_Link",
      children: /*#__PURE__*/_jsx(ChevronLeftSmallIcon, {
        "data-id": "pagination_index_LinkPagination_Link_ChevronLeftSmallIcon"
      })
    }), pages.map(page => /*#__PURE__*/_jsx(Link, {
      href: makePageLink(page),
      prefetch: false,
      "aria-label": "Go to page ".concat(page + 1),
      sx: _objectSpread(_objectSpread({}, buttonStyles), {}, {
        color: 'textPrimary',
        border: page === currentPage ? '1px solid' : '0',
        borderColor: page === currentPage ? 'borderPrimary' : 'transparent',
        pointerEvents: page === currentPage ? 'none' : 'auto'
      }),
      onClick: () => onLinkClick_(page),
      "data-id": "pagination_index_LinkPagination_Link",
      children: page + 1
    }, "go-to-page-".concat(page + 1))), onLastPage ? /*#__PURE__*/_jsx(Box, {
      sx: _objectSpread(_objectSpread({}, buttonStyles), {}, {
        pointerEvents: 'none'
      }),
      "data-id": "pagination_index_LinkPagination_Box",
      children: /*#__PURE__*/_jsx(ChevronRightSmallIcon, {
        sx: {
          color: 'iconDisabled'
        },
        "data-id": "pagination_index_LinkPagination_Box_ChevronRightSmallIcon"
      })
    }) : /*#__PURE__*/_jsx(Link, {
      href: makePageLink(currentPage + 1),
      prefetch: false,
      sx: _objectSpread({}, buttonStyles),
      "aria-label": "Go to next page",
      onClick: () => onLinkClick_(currentPage + 1),
      "data-id": "pagination_index_LinkPagination_Link",
      children: /*#__PURE__*/_jsx(ChevronRightSmallIcon, {
        "data-id": "pagination_index_LinkPagination_Link_ChevronRightSmallIcon"
      })
    })]
  });
};